"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var cashSummaryBlocksStyles = makeStyles_1.default(function (theme) { return ({
    title: {
        fontFamily: theme.typography.fontFamily2,
    },
    cashSummaryBlocksWrapper: {
        fontFamily: theme.typography.fontFamily,
    },
    divider: {
        margin: '0 5px',
    },
}); }, { name: 'Summary_CashSummaryBlocks' });
exports.default = cashSummaryBlocksStyles;
